<template>
    <div class="certificate min-height">
        <img :src="certificate" alt="" class="margin-right">
        <div class="flex align-center justify-around" v-if="certificate">
            <el-link :href="certificate" target="_blank" class="certificate-down"><el-button type="primary" class="certificate-down">证书下载</el-button></el-link>
            <el-link :href="certificate2" target="_blank" class="certificate-down"><el-button type="primary" class="certificate-down">证书打印</el-button></el-link>
        </div>
    </div>
</template>

<script>
import {certDetail, certPrint} from "@/api/member";
export default {
    name: "memberCertificate",
    data() {
        return {
            certificate:'',
            certificate2:''
        }
    },
    created() {
        this.$emit("setIndex", '/admin/member', "会员管理  / 会员证书", true, 'icon-zhengshu-copy');
        this.getDetail()
        this.getDetail2()
    },
    components: {},
    methods: {
        async getDetail(){
            let _data = await certDetail(this.$route.params.id)
            if(_data.status === 200) {
                this.certificate = _data.data
            }
        },
        async getDetail2(){
            let _data = await certPrint(this.$route.params.id)
            if(_data.status === 200) {
                this.certificate2 = _data.data
            }
        }
    },
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss">
.certificate{
    background: #fff;
    padding: 30px;
    border-radius: 8px;
    img{
        display: block;
        width: 500px;
        margin: 0 auto 30px;
    }
    .certificate-down{
        display: block;
        width: 200px;
        margin: 0 auto;
    }
}
</style>